import { Skeleton } from '@/components/lemmala-design-system/skeleton/skeleton'

import { PLACEHOLDER_COUNT } from './consts'
import { ASSESSMENT_COMMENTS_LABELS } from './labels'

// Traces AssessmentCommentThread. The generic Loading is built for page bodies and cramps a rail.
export const AssessmentCommentsSkeleton = () => (
  <div
    role='status'
    aria-label={ASSESSMENT_COMMENTS_LABELS.loading}
    className='flex flex-col gap-3'
  >
    {[...Array(PLACEHOLDER_COUNT)].map((_, index) => (
      <div
        key={index}
        className='flex flex-col gap-3 rounded border border-main-border-default bg-main-background-card p-3'
      >
        <div className='flex items-center gap-1.5'>
          <Skeleton className='size-6 shrink-0 rounded-full' />
          <Skeleton className='h-4 w-24' />
        </div>
        <div className='flex flex-col gap-1.5 pl-8'>
          <Skeleton className='h-4 w-full' />
          <Skeleton className='h-4 w-7/12' />
        </div>
      </div>
    ))}
  </div>
)
